<nav
  class="ds-navbar"
  [class.ds-navbar--sticky]="sticky"
  [class.ds-navbar--embedded]="embedded"
  [style.--ds-navbar-current-height]="height"
>
  <div class="ds-navbar__inner">
    @if (showBrand) {
      @if (brandHref) {
        <a class="ds-navbar__brand" [href]="brandHref">
          {{ brandLabel }}
        </a>
      } @else {
        <a class="ds-navbar__brand" [routerLink]="brandRoute">
          {{ brandLabel }}
        </a>
      }
    }

    <button
      type="button"
      class="ds-navbar__toggle"
      [attr.aria-label]="mobileMenuLabel"
      [attr.aria-expanded]="mobileMenuOpen ? 'true' : 'false'"
      (click)="toggleMobileMenu()"
    >
      <span class="ds-navbar__toggle-line"></span>
      <span class="ds-navbar__toggle-line"></span>
      <span class="ds-navbar__toggle-line"></span>
    </button>

    <div class="ds-navbar__menu" [class.ds-navbar__menu--open]="mobileMenuOpen">
      <ul class="ds-navbar__list">
        @for (item of items; track trackByLabel($index, item)) {
          <li
            class="ds-navbar__item"
            [class.ds-navbar__item--has-dropdown]="hasChildren(item)"
            [class.ds-navbar__item--dropdown-open]="isDropdownOpen(item)"
          >
            @if (hasChildren(item)) {
              <button
                type="button"
                class="ds-navbar__trigger"
                [disabled]="item.disabled || false"
                [attr.aria-expanded]="isDropdownOpen(item) ? 'true' : 'false'"
                (click)="toggleDropdown(item, $event)"
              >
                {{ item.label }}
                <span class="ds-navbar__caret" aria-hidden="true">▾</span>
              </button>

              <ul class="ds-navbar__dropdown">
                @for (child of item.children || []; track trackByLabel($index, child)) {
                  <li class="ds-navbar__dropdown-item">
                    @if (child.route) {
                      <a
                        class="ds-navbar__dropdown-link"
                        [routerLink]="child.route"
                        routerLinkActive="is-active"
                        [routerLinkActiveOptions]="{ exact: itemExact(child) }"
                        [attr.aria-disabled]="child.disabled ? 'true' : null"
                        (click)="onItemClick(child)"
                      >
                        {{ child.label }}
                      </a>
                    } @else if (child.href) {
                      <a
                        class="ds-navbar__dropdown-link"
                        [href]="child.href"
                        [attr.target]="child.target || null"
                        [attr.rel]="child.target === '_blank' ? 'noopener noreferrer' : null"
                        [attr.aria-disabled]="child.disabled ? 'true' : null"
                        (click)="onItemClick(child)"
                      >
                        {{ child.label }}
                      </a>
                    } @else {
                      <button
                        type="button"
                        class="ds-navbar__dropdown-link"
                        [disabled]="child.disabled || false"
                        (click)="onItemClick(child)"
                      >
                        {{ child.label }}
                      </button>
                    }
                  </li>
                }
              </ul>
            } @else if (item.route) {
              <a
                class="ds-navbar__link"
                [routerLink]="item.route"
                routerLinkActive="is-active"
                [routerLinkActiveOptions]="{ exact: itemExact(item) }"
                [attr.aria-disabled]="item.disabled ? 'true' : null"
                (click)="onItemClick(item)"
              >
                {{ item.label }}
              </a>
            } @else if (item.href) {
              <a
                class="ds-navbar__link"
                [href]="item.href"
                [attr.target]="item.target || null"
                [attr.rel]="item.target === '_blank' ? 'noopener noreferrer' : null"
                [attr.aria-disabled]="item.disabled ? 'true' : null"
                (click)="onItemClick(item)"
              >
                {{ item.label }}
              </a>
            } @else {
              <button
                type="button"
                class="ds-navbar__link"
                [disabled]="item.disabled || false"
                (click)="onItemClick(item)"
              >
                {{ item.label }}
              </button>
            }
          </li>
        }
      </ul>

      <div class="ds-navbar__actions">
        <ng-content select="[navbarActions]"></ng-content>
      </div>
    </div>
  </div>
</nav>